import { createElementVNode as _createElementVNode, withKeys as _withKeys, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = {
  ref: "content",
  class: "sheet-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Metadata = _resolveComponent("Metadata")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "sheet",
    class: _normalizeClass(["viewer-bottom-sheet", { dragging: _ctx.dragging, closing: _ctx.closing }]),
    role: "dialog",
    "aria-label": _ctx.t('memories', 'Info'),
    style: {"top":"10000px"},
    onClickCapture: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickCapture && _ctx.onClickCapture(...args))),
    onTouchstartPassive: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDragStart && _ctx.onDragStart(...args))),
    onTouchend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDragEnd && _ctx.onDragEnd(...args))),
    onTouchcancel: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onDragCancel && _ctx.onDragCancel(...args)))
  }, [
    _createElementVNode("div", {
      class: "sheet-handle-area",
      role: "button",
      tabindex: "0",
      "aria-label": _ctx.expanded ? _ctx.t('memories', 'Collapse details') : _ctx.t('memories', 'Expand details'),
      onKeydown: [
        _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toggleOpen && _ctx.toggleOpen(...args)), ["enter"])),
        _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleOpen && _ctx.toggleOpen(...args)), ["prevent"]), ["space"]))
      ]
    }, [...(_cache[6] || (_cache[6] = [
      _createElementVNode("div", { class: "sheet-handle" }, null, -1)
    ]))], 40, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Metadata, { ref: "metadata" }, null, 512)
    ], 512)
  ], 42, _hoisted_1))
}